/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:client-app:fallback-client-app */

export interface FallbackClientAppBlockParams {
	isSolutionView?: boolean;
}
/** Block parameters for urn:block:client-app:files-with-background */

export interface FilesWithBackgroundBlockParams {
	containerRID?: string;
}
/** Block parameters for urn:block:client-app:page */

export interface PageBlockParams {
	accountId?: string;
}
/** Zone parameters for urn:zone:client-app:page:content */

export interface PageContentZoneParams {}
/** Zone parameters for urn:zone:client-app:page:footer */

export interface PageFooterZoneParams {}
/** Block parameters for urn:block:client-app:with-navigation-zones */

export interface WithNavigationZonesBlockParams {
	accountRID?: string;
	isSolutionView?: boolean;
}
/** Zone parameters for urn:zone:client-app:root-shell:top-level-navigation */

export interface RootShellTopLevelNavigationZoneParams {
	path: string;
	iconName?: string;
	/**
	 * Localized String Values
	 */
	title: {
		en?: string;
		es?: string;
		de?: string;
		fr?: string;
		it?: string;
		ja?: string;
		nl?: string;
		'pt-BR'?: string;
	};
	/**
	 * Tour step registration
	 */
	tourStep?: {
		/**
		 * Title of the tour step dialog
		 */
		title: {
			en?: string;
			es?: string;
			de?: string;
			fr?: string;
			it?: string;
			ja?: string;
			nl?: string;
			'pt-BR'?: string;
		};
		/**
		 * Description of the tour step dialog
		 */
		description?: {
			en?: string;
			es?: string;
			de?: string;
			fr?: string;
			it?: string;
			ja?: string;
			nl?: string;
			'pt-BR'?: string;
		};
		placement?:
			| 'left'
			| 'leftTop'
			| 'leftBottom'
			| 'right'
			| 'rightTop'
			| 'rightBottom'
			| 'top'
			| 'topLeft'
			| 'topRight'
			| 'bottom'
			| 'bottomLeft'
			| 'bottomRight'
			| 'center';
		/**
		 * Style of tour step dialog
		 */
		style?: {
			width?: string | number;
		};
		weight: number;
		analyticsId?: string;
	};
	exact?: boolean;
}
/** Zone parameters for urn:zone:client-app:root-shell:solution-installed */

export interface RootShellSolutionInstalledZoneParams {}

export namespace BlockNames {
	export const FallbackClientApp = 'urn:block:client-app:fallback-client-app' as const;
	export type FallbackClientApp = 'urn:block:client-app:fallback-client-app';
	export const FilesWithBackground =
		'urn:block:client-app:files-with-background' as const;
	export type FilesWithBackground = 'urn:block:client-app:files-with-background';
	export const Page = 'urn:block:client-app:page' as const;
	export type Page = 'urn:block:client-app:page';
	export const WithNavigationZones =
		'urn:block:client-app:with-navigation-zones' as const;
	export type WithNavigationZones = 'urn:block:client-app:with-navigation-zones';
}

export namespace ZoneTypes {
	export const PageContent = 'urn:zone:client-app:page:content' as const;
	export type PageContent = 'urn:zone:client-app:page:content';
	export const PageFooter = 'urn:zone:client-app:page:footer' as const;
	export type PageFooter = 'urn:zone:client-app:page:footer';
	export const RootShellTopLevelNavigation =
		'urn:zone:client-app:root-shell:top-level-navigation' as const;
	export type RootShellTopLevelNavigation =
		'urn:zone:client-app:root-shell:top-level-navigation';
	export const RootShellSolutionInstalled =
		'urn:zone:client-app:root-shell:solution-installed' as const;
	export type RootShellSolutionInstalled =
		'urn:zone:client-app:root-shell:solution-installed';
}

export type FallbackClientAppProps = ShellProps &
	BlockParams &
	FallbackClientAppBlockParams;
export type FilesWithBackgroundProps = ShellProps &
	BlockParams &
	FilesWithBackgroundBlockParams;
export type PageProps = ShellProps & BlockParams & PageBlockParams;
export type WithNavigationZonesProps = ShellProps &
	BlockParams &
	WithNavigationZonesBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:client-app:fallback-client-app']: BlockParams &
			FallbackClientAppBlockParams;
		['urn:block:client-app:files-with-background']: BlockParams &
			FilesWithBackgroundBlockParams;
		['urn:block:client-app:page']: BlockParams & PageBlockParams;
		['urn:block:client-app:with-navigation-zones']: BlockParams &
			WithNavigationZonesBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:client-app:page:content']: PageContentZoneParams;
		['urn:zone:client-app:page:footer']: PageFooterZoneParams;
		['urn:zone:client-app:root-shell:top-level-navigation']: RootShellTopLevelNavigationZoneParams;
		['urn:zone:client-app:root-shell:solution-installed']: RootShellSolutionInstalledZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:client-app:page:content']: never;
		['urn:zone:client-app:page:footer']: never;
		['urn:zone:client-app:root-shell:top-level-navigation']: never;
		['urn:zone:client-app:root-shell:solution-installed']: never;
	}
}
